module.exports = __webpack_public_path__ + "img/prize5.752ec86c.png";